module.exports = __webpack_public_path__ + "static/media/logo_.39bec957.png";